import React from "react";

import { setupActions } from '../actions';
import { connect } from 'react-redux'

import { Spinner } from 'components/Icons/Spinner';
import {
  Row,
  Col 
} from "reactstrap";

import NewProfileImages from '../components/NewProfileImages'
import { Kpis } from '../components/Kpis';
import LastCommits from '../components/LastCommits';
import { ActiveSessions } from '../components/ActiveSessions';


var viewActions = require ('store/view.actions');

class DashBoard extends React.Component {

  componentDidMount() {
    this.props.setMainTitle("Panel de control", [] );
    this.props.getUserDashboard ( this.props.token );
    this.props.getKpis( this.props.token); 
  }

  constructor(props) {
    super(props);
    this.state = {
    
    }

 }

  render() {
    return (
      <>
        <div className="content">
        {!this.props.view.loadingModules.getUserDashboard ?
          <Row>
            <Col md="12">
              <Row>
                {this.props.kpis.sessions && 
                  <ActiveSessions sessions={this.props.kpis.sessions} />
                }
              </Row>               
              {this.props.userDashboardOjects.map( (obj) => {
                
                  return (
                    <>
                    {obj.dash_object_id === 'NEW_PROFILE_IMAGE' && 
                      <NewProfileImages />
                    }
                    {obj.dash_object_id === 'KPIS' && 
                      <Kpis 
                        values={this.props.kpis}
                      />
                    }
                    {obj.dash_object_id === 'LAST_COMMITS' && 
                      <LastCommits />
                    }
                    </>
                  )
                  }
                )
              }  

            </Col>
            
          </Row>
        :
        <Spinner size="XL" />
      }
        </div>
      </>
    );
  }
}

 const mapStateToProps = state => {
    return {
        currentCalendarID:  state.school.currentCalendarID,
        view: state.view,
        school: state.config.school,
        token: state.auth.session.jwt_token,
        userDashboardOjects: state.setup.userDashboardOjects,
        kpis: state.setup.kpis
     }
  }

  
  const mapDispatchToProps = dispatch => {
    return { 
      setMainTitle: ( title, menu ) => {
          dispatch(viewActions.setMainTitle( title, menu ))
        },
      getUserDashboard: ( token ) => {
        dispatch( setupActions.getUserDashboard( token )) ;
      },
      getKpis: ( token ) => {
        dispatch( setupActions.getKpis( token )) ;
      }
        

 
    }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(DashBoard);

